import { useForm } from "react-hook-form";

export default function useNodeForm() {
  const form = useForm({
    defaultValues: {},
  });
  return { form };
}
